import React, { Component, Fragment } from "react";
import ModalTooLongContent from "../../../shared/ModalTooLongContent/ModalTooLongContent";
import ModalTooLongContentTitle from "../../../shared/ModalTooLongContent/ModalTooLongContentTitle";
import Textarea from "../../../shared/Textarea/Textarea";
import Loading from "../../../shared/Loading/Loading";
import Radio from "../../../shared/Radio/Radio";

class DeleteOfferModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			reason: undefined,
			comment: "",
			errorComment: undefined,
			errorReason: undefined,
			valid: false
		};
	}
	close = () => {
		this.props.close();
	};

	confirm = () => {
		let { errorReason, errorComment } = this.state;
		if (!this.state.reason) {
			errorReason = "Selecione uma opção para prosseguir";
			this.setState({ errorReason });
		} else if (this.state.reason.id == 5 && this.state.comment == "") {
			errorComment = "Campo obrigatório";
			this.setState({ errorComment, valid: false });
		} else {
			this.props.confirm(this.state.reason, this.state.comment);
		}
	};

	onChangeComment = e => {
		this.setState({
			comment: e.target.value,
			errorComment: undefined,
			valid: true
		});
	};

	handleReason = e => {
		let id = e.value;
		let name = e.label;
		if (this.state.errorComment && id != 5) {
			this.setState({
				reason: { id, name },
				errorComment: undefined,
				errorReason: undefined,
				valid: true
			});
		} else {
			this.setState({
				reason: { id, name },
				errorReason: undefined,
				valid: true
			});
		}
		document.getElementById("comment").focus();
	};

	render() {
		const { options } = this.props;
		const { valid } = this.state;
		let radioOptions = options.map(option => {
			return {
				value: option.id,
				label: option.name
			};
		});

		return (
			<div className="delete-offer-modal">
				<ModalTooLongContent>
					<div className="delete-offer-modal__panel">
						<div>
							<ModalTooLongContentTitle
								close={this.close}
								title={
									window.screen.availWidth <= 468
										? `Por que você está \n excluindo sua oferta?`
										: "Por que você está excluindo sua oferta?"
								}
							/>
						</div>
						<div className="delete-offer-modal__content">
							<Radio
								onChange={this.handleReason}
								horizontally={false}
								errorMessage={this.state.errorReason}
								options={radioOptions}
							/>

							<Textarea
								id="comment"
								className="delete-offer-modal__comment"
								errorMessage={this.state.errorComment}
								onChange={this.onChangeComment}
								placeholder="Conte mais pra gente"
								valid={valid}
							/>
						</div>
						<div className="delete-offer-modal--buttons text-right">
							<button className="btn-gray-lg-o" onClick={this.close}>
								Cancelar
							</button>
							<button className="btn-primary-lg" onClick={this.confirm}>
								Excluir oferta
							</button>
						</div>
						{this.props.loading ? (
							<Loading className="delete-offer-modal__loading" />
						) : (
							<Fragment />
						)}
					</div>
				</ModalTooLongContent>
			</div>
		);
	}
}

export default DeleteOfferModal;
